import { getUrls } from '@zapier/product-dev-platform/src/utils/urls';

export const getNavLinks = (
  isLoadingUser: boolean,
  isAuthed: boolean,
  host: string
) => {
  const urls = getUrls(host);

  const integrationLink = isLoadingUser
    ? // This is an invisible placeholder preventing jumpy UX for
      // unauthenticated visitors.
      {
        href: urls.buildIntegration,
        isVisible: false,
        label: 'Build integration',
      }
    : isAuthed
    ? {
        href: urls.vbBase,
        isVisible: true,
        label: 'My integrations',
      }
    : {
        href: urls.buildIntegration,
        isVisible: true,
        label: 'Build integration',
      };

  const zapTemplatesLink = isLoadingUser
    ? // This is an invisible placeholder preventing jumpy UX for
      // unauthenticated visitors.
      {
        href: urls.zapTemplates,
        isVisible: false,
        label: 'Zap templates',
      }
    : {
        href: urls.zapTemplates,
        isVisible: true,
        label: 'Zap templates',
      };

  const fixedLinks = [
    {
      href: urls.docs,
      isVisible: true,
      label: 'Docs',
    },
    {
      href: urls.tools,
      isVisible: true,
      label: 'Tools',
    },
    {
      href: urls.partnerProgram,
      isVisible: true,
      label: 'Partner program',
    },
    {
      href: urls.resources,
      isVisible: true,
      label: 'Resources',
    },
  ];

  return [integrationLink, zapTemplatesLink, ...fixedLinks];
};
